import { hasClientConsentCategory } from "privacy-consent";

type LocalStorageOptions = {
  consentCategory?: string;
  requireConsent?: boolean;
};

const DEFAULT_LOCAL_STORAGE_CONSENT_CATEGORY = "2";

export const getFromLocalStorage = (key: string, options: LocalStorageOptions = {}): string | null => {
  try {
    if (typeof localStorage === "undefined") return null;

    const { consentCategory = DEFAULT_LOCAL_STORAGE_CONSENT_CATEGORY, requireConsent = true } = options;
    if (requireConsent && !hasClientConsentCategory(consentCategory)) {
      localStorage.removeItem(key);
      return null;
    }

    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

export const setToLocalStorage = (key: string, value: string, options: LocalStorageOptions = {}): void => {
  try {
    if (typeof localStorage === "undefined") return;

    const { consentCategory = DEFAULT_LOCAL_STORAGE_CONSENT_CATEGORY, requireConsent = true } = options;
    if (requireConsent && !hasClientConsentCategory(consentCategory)) {
      localStorage.removeItem(key);
      return;
    }

    localStorage.setItem(key, value);
    return;
  } catch (error) {
    return;
  }
};

export const removeFromLocalStorage = (key: string): void => {
  try {
    if (typeof localStorage === "undefined") return;

    localStorage.removeItem(key);
  } catch (error) {
    return;
  }
};
